/**
 * Abre un PDF en nueva pestaña sin disparar el bloqueador de popups.
 *
 * El truco: window.open se llama en el mismo tick del evento de usuario (antes del
 * await), de modo que el browser lo trata como acción iniciada por el usuario.
 * Luego se navega la pestaña ya abierta a la URL definitiva.
 *
 * @param fetchUrl  Función async que retorna el presigned URL, o null/undefined en error.
 * @param onError   Callback para mostrar mensajes de error al usuario.
 * @param errorMsg  Mensaje específico cuando fetchUrl falla o devuelve vacío.
 * @returns true si el PDF se abrió con éxito, false en cualquier caso de fallo.
 */
const LOADING_HTML = `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Generando informe…</title>
  <style>
    *{box-sizing:border-box;margin:0;padding:0}
    body{
      display:flex;align-items:center;justify-content:center;
      min-height:100vh;background:#f5f5f5;
      font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;
    }
    .wrap{text-align:center}
    .spinner{
      width:44px;height:44px;border:3px solid #e0e0e0;
      border-top-color:#5A1C70;border-radius:50%;
      animation:spin .8s linear infinite;margin:0 auto 18px;
    }
    @keyframes spin{to{transform:rotate(360deg)}}
    p{font-size:15px;color:#666}
  </style>
</head>
<body>
  <div class="wrap">
    <div class="spinner"></div>
    <p>Generando informe…</p>
  </div>
</body>
</html>`;

export async function abrirInformePDF(
  fetchUrl: () => Promise<string | null | undefined>,
  onError: (msg: string) => void,
  errorMsg: string,
): Promise<boolean> {
  const win = window.open('', '_blank');
  if (!win) {
    onError(
      'Tu navegador bloqueó la apertura del informe. Permitir popups para este sitio e intentar de nuevo.',
    );
    return false;
  }

  win.document.write(LOADING_HTML);
  win.document.close();

  try {
    const url = await fetchUrl();
    if (url) {
      win.location.href = url;
      return true;
    }
    win.close();
    onError(errorMsg);
    return false;
  } catch {
    win.close();
    onError(errorMsg);
    return false;
  }
}
